// This is a saved result set from {api}/meta/content_types

import * as actionTypes from "../actions/actionTypes";
/**
 * Stores the allowed content types
 *
 * {
 *    asset: [types]
 *    asset-PNG: [types] // replacment types for a PNG asset
 *    supporting_image-PNG: [types] // replacment types for a PNG supporting image
 * }
 */
export default function contentTypes(state = {}, action) {
  if (action.type === actionTypes.FETCH_CONTENT_TYPES_SUCCESS) {
    const {
      itemType,
      assetType,
      response: { content_types: fileTypes },
    } = action;

    const types = Object.values(fileTypes);
    const key = [itemType, assetType].filter(v => v).join("-");
    return { ...state, [key]: types };
  }

  return state;
}
